import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { ForgottenPasswordRequestVM } from '../../../models';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'ForgottenComponent',
  templateUrl: './forgotten.component.html'
})
export class ForgottenComponent extends BaseComponent implements OnInit {
  email: string;
  message: string;
  actionComplete: boolean;

  constructor(private route: ActivatedRoute, private fb: FormBuilder, private authService: AuthService) {
    super(route)
  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      email: new FormControl(null, [Validators.email, Validators.required])
    });
  }

  onSubmit(): void {
    if (this.myForm.valid) {
      let request = new ForgottenPasswordRequestVM();
      request.username = this.email;

      var self = this;
      this.emitDisplayLoadingDialog(true);

      this.authService.forgottenPassword(request)
        .subscribe(returnValue => {
          self.message = returnValue.message;
          if (returnValue.success) {
            self.actionComplete = true;
          } else {
            self.showDialog(this.message, true);
          }
          this.emitDisplayLoadingDialog(false);
        },
          error => {
            self.message = error;
            this.emitDisplayLoadingDialog(false);
            self.showDialog(this.message, true);
          }
        )
    }
    else {
      this.markAsTouched(this.myForm);
    }
  }
}
